<div class="col-span-12">
    <div
        class="grid md:grid-cols-12 gap-4 backdrop-blur-3xl p-4 md:p-6 bg-white dark:bg-surface-1 rounded-lg border border-white/20 dark:border-line shadow-sm">
        <div class="md:col-span-8 w-full h-full relative">
            <!-- <app-cards 
            [data]="cardsData"
            [valueKey]="'total_contracts'"
            [cardHeading]="'Total Contracts'"
            [tableHeaders]="cardsData['tableHeaders']"
            [isClassHide]="true"
            [curveType]="'curveLinear'"
            [showToggle]="true"
            [unit]="dateRange.unit || 'day'">
          </app-cards> -->
            <div class="flex justify-between mb-3">
                <div class="flex flex-col">
                    <div class="mb-4">
                        <span
                            class="bg-slate-100 dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs py-1 px-3 rounded-md transition-colors duration-200">{{
                            cardsData.allTimeHeading }}: {{ cardsData?.summary?.allTime ?? cardsData?.allTime ?? 0
                            }}</span>
                    </div>
                    <div class="flex flex-1">
                        <div class="flex flex-col mr-5">
                            <div class="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
                                <span class="w-2 h-2 rounded-full bg-[#AD46FF] dark:bg-purple-500 inline-block"></span>
                                <span>Current: <span class="font-semibold text-slate-800 dark:text-slate-100">{{
                                        cardsData?.summary?.current
                                        ?? cardsData?.current ?? 0 }}</span></span>
                            </div>
                            <div>
                                <span class="flex items-center">Financed: &nbsp;<span
                                        class="font-semibold text-slate-800 dark:text-slate-100 flex items-center">{{
                                        cardsData?.summary?.financed
                                        ?? cardsData?.financed ?? 0 | currency }} &nbsp;
                                        <span class="relative inline-block" (mouseenter)="showCurrentTooltip = true"
                                            (mouseleave)="showCurrentTooltip = false">
                                            <app-icon name="info" [size]="18" class="cursor-help"></app-icon>
                                            @if(showCurrentTooltip) {
                                            <div
                                                class="absolute left-0 top-6 z-50 w-64 p-3 bg-white dark:bg-slate-800 text-slate-800 dark:text-white text-xs rounded-lg shadow-xl border border-slate-200 dark:border-slate-600">
                                                <div
                                                    class="font-semibold mb-2 text-slate-900 dark:text-slate-100 tracking-wider">
                                                    Finance Breakdown</div>
                                                <div class="space-y-2">
                                                    <div class="flex justify-between items-center">
                                                        <span class="text-slate-600 dark:text-slate-300">Service
                                                            Amount:</span>
                                                        <span class="font-semibold text-slate-900 dark:text-white">{{
                                                            cardsData?.summary?.service_amount ?? 0 | currency }}</span>
                                                    </div>
                                                    <div class="h-px bg-slate-200 dark:bg-slate-700"></div>
                                                    <div class="flex justify-between items-center">
                                                        <span class="text-slate-600 dark:text-slate-300">Down
                                                            Payment:</span>
                                                        <span class="font-semibold text-slate-900 dark:text-white">{{
                                                            cardsData?.summary?.downPayment_amount ?? 0 | currency
                                                            }}</span>
                                                    </div>
                                                </div>
                                                <!-- Arrow pointer -->
                                                <div
                                                    class="absolute -top-1 left-4 w-2 h-2 bg-white dark:bg-slate-800 border-l border-t border-slate-200 dark:border-slate-600 transform rotate-45">
                                                </div>
                                            </div>
                                            }
                                        </span>
                                    </span></span>
                            </div>
                        </div>
                        @if(cardsData?.summary?.previous) {
                        <div class="flex flex-col">
                            <div class="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
                                <span class="w-2 h-2 rounded-full bg-slate-400 dark:bg-slate-500 inline-block"></span>
                                <span>Previous: <span class="font-semibold text-slate-800 dark:text-slate-100">{{
                                        cardsData?.summary?.previous ?? cardsData?.previous ?? 0 }}</span></span>
                            </div>
                            <div>
                                <span class="flex items-center">Financed: &nbsp;<span
                                        class="font-semibold text-slate-800 dark:text-slate-100 flex items-center">{{
                                        cardsData?.summary?.previous_financed
                                        ?? cardsData?.previous_financed ?? 0 | currency }} &nbsp;
                                        <span class="relative inline-block" (mouseenter)="showPreviousTooltip = true"
                                            (mouseleave)="showPreviousTooltip = false">
                                            <app-icon name="info" [size]="18" class="cursor-help"></app-icon>
                                            @if(showPreviousTooltip) {
                                            <div
                                                class="absolute left-0 top-6 z-50 w-64 p-3 bg-white dark:bg-slate-800 text-slate-800 dark:text-white text-xs rounded-lg shadow-xl border border-slate-200 dark:border-slate-600">
                                                <div
                                                    class="font-semibold mb-2 text-slate-900 dark:text-slate-100 tracking-wider">
                                                    Finance Breakdown</div>
                                                <div class="space-y-2">
                                                    <div class="flex justify-between items-center">
                                                        <span class="text-slate-600 dark:text-slate-300">Service
                                                            Amount:</span>
                                                        <span class="font-semibold text-slate-900 dark:text-white">{{
                                                            cardsData?.summary?.previous_service_amount ?? 0 | currency
                                                            }}</span>
                                                    </div>
                                                    <div class="h-px bg-slate-200 dark:bg-slate-700"></div>
                                                    <div class="flex justify-between items-center">
                                                        <span class="text-slate-600 dark:text-slate-300">Down
                                                            Payment:</span>
                                                        <span class="font-semibold text-slate-900 dark:text-white">{{
                                                            cardsData?.summary?.previous_downPayment_amount ?? 0 |
                                                            currency }}</span>
                                                    </div>
                                                </div>
                                                <!-- Arrow pointer -->
                                                <div
                                                    class="absolute -top-1 left-4 w-2 h-2 bg-white dark:bg-slate-800 border-l border-t border-slate-200 dark:border-slate-600 transform rotate-45">
                                                </div>
                                            </div>
                                            }
                                        </span>
                                    </span></span>
                            </div>
                        </div>
                        }
                    </div>
                </div>

                <div>
                    <app-toggle-btns (viewChanged)="viewChanged($event)"></app-toggle-btns>
                </div>
            </div>


            <div class="cards-views mt-5 h-[350px]">
                @if(viewSignal() === 'chart') {
                <div class="h-full w-full">
                    <app-line-chart [data1]="$safeNavigationMigration(cardsData?.chartData)" [data2]="$safeNavigationMigration(cardsData?.previousChartData)"
                        [valueKey]="cardsData?.valueKey || 'total_contracts'" [unit]="dateRange.unit || 'day'"
                        [showYAxis]="false" [showYAxisGrid]="false" [showYAxisPath]="true" [curveType]="'curveLinear'">
                    </app-line-chart>
                </div>
                }
                @if(viewSignal() === 'table') {
                <div class="h-full overflow-hidden relative">
                    <app-scroll-table [tableData]="$safeNavigationMigration(cardsData?.tableData)" [previousData]="$safeNavigationMigration(cardsData?.previousTableData)"
                        [headers]="tableHeaders" [showHeading]="false" (cellHover)="onCellHover($event)">
                    </app-scroll-table>

                    <!-- Custom Tooltip -->
                    @if(tooltipVisible && hoveredRowData) {
                    <div class="absolute z-50 bg-[#3C444D] text-white rounded-lg p-3 shadow-xl border border-gray-600 pointer-events-none min-w-[150px]"
                        [style.left.px]="tooltipPosition.x" [style.top.px]="tooltipPosition.y">
                        <div class="flex items-center justify-between gap-4 mb-1">
                            <span class="text-[#B6BCC4] text-sm">No Fee:</span>
                            <span class="text-white font-semibold text-sm">{{ hoveredRowData.noFee ??
                                hoveredRowData.nofee ?? 0 }}</span>
                        </div>
                        <div class="flex items-center justify-between gap-4 mb-1">
                            <span class="text-[#B6BCC4] text-sm">10%:</span>
                            <span class="text-white font-semibold text-sm">{{ hoveredRowData.tenPercent ??
                                hoveredRowData.tenpercent ?? 0 }}</span>
                        </div>
                        <div class="flex items-center justify-between gap-4 mb-1">
                            <span class="text-[#B6BCC4] text-sm">InHouse:</span>
                            <span class="text-white font-semibold text-sm">{{ hoveredRowData.inhouse ??
                                hoveredRowData.inHouse ?? 0 }}</span>
                        </div>
                        <div class="flex items-center justify-between gap-4 mb-1">
                            <span class="text-[#B6BCC4] text-sm">EZ:</span>
                            <span class="text-white font-semibold text-sm">{{ hoveredRowData.ez ?? 0 }}</span>
                        </div>
                        <div class="flex items-center justify-between gap-4 mb-1">
                            <span class="text-[#B6BCC4] text-sm">EZ Deferred:</span>
                            <span class="text-white font-semibold text-sm">{{ hoveredRowData.ez_deferred ??
                                hoveredRowData.ezDeferred ?? 0 }}</span>
                        </div>
                        <div class="flex items-center justify-between gap-4 mb-0">
                            <span class="text-[#B6BCC4] text-sm">AR:</span>
                            <span class="text-white font-semibold text-sm">{{ hoveredRowData.ar ?? 0 }}</span>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
 @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
        }
        </div>

        <!-- Right Section: Stats Panel (3/12 on md+) -->
        <div
            class="lg:col-span-4 col-span-12 w-full bg-[#272D35] rounded-xl py-4 px-8 text-[#DFE5ED] shadow-sm h-[450px] relative">
            <!-- <app-loader *ngIf="contracts.contractsToday.loading"></app-loader> -->
            <div class="w-full flex items-center justify-between flex-col gap-6"
                [class.blur-sm]="contracts.contractsToday.loading">
                <div class="w-full">
                    <div class="flex justify-start items-center gap-2">
                        <h2 class="m-0 p-0 text-lg font-semibold">
                            Contracts Created Today
                        </h2>
                        <svg class="w-5 h-5 text-gray-500 hover:text-gray-400 cursor-pointer" aria-hidden="true"
                            (click)="FetchContractsToday(false)" xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4" />
                        </svg>
                    </div>
                    <h2 class="text-3xl font-bold">
                        {{ contracts.contractsToday.total_contracts || 0 }}
                    </h2>
                </div>

                <div class="w-full flex flex-col justify-between gap-3 max-h-[350px] overflow-y-auto">
                    <div class="flex flex-col justify-between gap-2">
                        @for(contractType of contracts.contractsToday.contract_type_count; track
                        contractType.contract_type) {
                        <div class="flex items-center justify-between px-2.5">
                            <span class="flex items-center">
                                <!-- <span class="w-[10px] h-[10px] rounded-[3px] bg-[#FFBF47] mr-2"></span> -->
                                {{ contractType.contract_type_label }}
                            </span>
                            <span class="font-semibold">{{contractType.count || 0 }}</span>
                        </div>
                        <div class="bg-[#394048] h-[1px] rounded-md"></div>
                        }
                    </div>
                </div>
            </div>
            @if(isLoading()){
        <app-individual-toaster [loaderType]="'dark'"></app-individual-toaster>
        }
        </div>
       
    </div>
</div>